import { useEffect, useRef, useState } from 'react'

export function useCreationDrawLoop(fps?: number): number {
    const [frameCount, setFrameCount] = useState<number>(0)
    const [fpsFrameCount, setFpsFrameCount] = useState<number>(0)
    const lastFpsFrameTimeRef = useRef<number>(Date.now())

    useEffect(() => {
        const animationId = requestAnimationFrame(() => {
            // lock to fps (if provided)
            if (fps) {
                const now = Date.now()
                if (now - lastFpsFrameTimeRef.current >= 1000 / fps) {
                    lastFpsFrameTimeRef.current = now
                    setFpsFrameCount(fpsFrameCount + 1)
                }
            }
            setFrameCount(frameCount + 1)
        })
        return () => {
            cancelAnimationFrame(animationId)
        }
    }, [frameCount, fps])

    return fps ? fpsFrameCount : frameCount
}
